import { styled } from '@mui/material'
import Box from '@mui/material/Box'

export const TabsContainer = styled(Box)`
  .MuiTab-root {
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 500;
  }
`
